import { Link } from 'components/link/link';
import type { RoyaltyCheckSourceDocumentRef } from './types';

// Shared cell renderers for the two royalty-check list tables (the parent-row
// view in `columns.tsx` and the flat "one row per line item" view in
// `flat-table.tsx`), which render the RC Input Source and Created By columns
// identically.

interface SourceCellProps {
  source: string | null;
  sourceDocument: RoyaltyCheckSourceDocumentRef | null;
}

// Provisioned checks link to their originating document (mirrors the DO/AFE
// catalogs); Salesforce-sourced checks have no document, so render plain text.
export const SourceCell = ({ source, sourceDocument }: SourceCellProps) => {
  if (source === 'Provisioned' && sourceDocument?.href) {
    const title =
      sourceDocument.documentTitle ?? `Document #${sourceDocument.id}`;
    return (
      <Link to={sourceDocument.href} title={title}>
        Auto-Connected
      </Link>
    );
  }
  return <>{source ?? 'Salesforce'}</>;
};

interface CreatedByCellProps {
  source: string | null;
  createdByName: string | null;
}

// Provisioned (synthetic) checks have no Salesforce user, so created_by_name is
// indexed as null. Show 'System' to match the AFE/DO catalogs.
export const CreatedByCell = ({
  source,
  createdByName,
}: CreatedByCellProps) => (
  <>{source === 'Provisioned' ? 'System' : (createdByName ?? '--')}</>
);
